module.exports = __webpack_public_path__ + "img/guanyu_huaxiang@2x.e6eb3a8b.png";